import React, { useContext } from 'react';
import getSuitCSSClasses from '@/utils/getSuitCSSClasses';

import ViewControlGroup from '@/client/components/ViewControls/atoms/ViewControlGroup';
import SaveSearchContainer from '@/client/components/SaveSearch/SaveSearchContainer';
import ViewOptionsControl from '@/client/components/ViewControls/molecules/ViewOptionsControl';
import SorterControl from '@/client/components/ViewControls/molecules/SorterControl';
import useViewControls from '@/client/hooks/useViewControls';
import EnvironmentContext from '@/client/contexts/EnvironmentContext';
import experiments from '@/utils/labs/experiments';
import CATEGORIES_L1 from '@/constants/categories';

const classes = {
  root: getSuitCSSClasses({ namespace: 'hz', name: 'ViewControl' }),
};

export type TViewControlsProps = {
  searchRequestObject: TSearchRequestObject;
  sortOptions: TSortOption[];
  setIsSearchSaved: (isSearchSaved: boolean) => void;
  setSavedSearchId: (id: number) => void;
  isSearchSaved: boolean;
  savedSearchId: number | null;
  isSoiPage: boolean;
};

const ViewControls = ({
  sortOptions,
  searchRequestObject,
  setIsSearchSaved,
  isSearchSaved,
  setSavedSearchId,
  savedSearchId,
  isSoiPage,
}: TViewControlsProps) => {
  const {
    labsConfig,
    tenantContext: { tenant },
  } = useContext(EnvironmentContext);
  const {
    isFetchResultsOnceEnabled,
    isFetchResultsOnceAllCatEnabled,
    isFetchResultsHIOnceEnabled,
    isFloatingSaveSearchButtonEnabled,
  } = experiments({
    labsConfig,
  });
  const withAllAttributes =
    isFetchResultsOnceAllCatEnabled ||
    (isFetchResultsOnceEnabled && searchRequestObject.categories?.l1Category?.id === CATEGORIES_L1.DAMES_KLEREN) ||
    (isFetchResultsHIOnceEnabled &&
      tenant === 'mp' &&
      searchRequestObject.categories?.l1Category?.id === CATEGORIES_L1.HUIS_EN_INRICHTING);
  const { handleViewOptionsChange } = useViewControls(searchRequestObject, withAllAttributes);
  const { viewOptions } = searchRequestObject;

  return (
    <>
      <div className={classes.root}>
        <ViewControlGroup type="functional-options">
          {!isSoiPage && (
            <SaveSearchContainer
              setIsSearchSaved={setIsSearchSaved}
              isSearchSaved={isSearchSaved}
              setSavedSearchId={setSavedSearchId}
              savedSearchId={savedSearchId}
              searchRequestObject={searchRequestObject}
              className={`hz-SaveSearchButton`}
            />
          )}
        </ViewControlGroup>
        <ViewControlGroup type="view-and-sort-options">
          <ViewOptionsControl kind={viewOptions.kind} onChange={handleViewOptionsChange} />
          <SorterControl
            searchRequestObject={searchRequestObject}
            sortOptions={sortOptions}
            withAllAttributes={withAllAttributes}
          />
        </ViewControlGroup>
      </div>
      <ViewControlGroup type="functional-options">
        {!isSoiPage && (
          <SaveSearchContainer
            setIsSearchSaved={setIsSearchSaved}
            isSearchSaved={isSearchSaved}
            setSavedSearchId={setSavedSearchId}
            savedSearchId={savedSearchId}
            searchRequestObject={searchRequestObject}
            className={`hz-SaveSearchButton--mobileAdapted ${isFloatingSaveSearchButtonEnabled ? 'hz-hidden' : ''}`}
          />
        )}
      </ViewControlGroup>
    </>
  );
};

export default ViewControls;
